import React from "react";
import { motion } from "framer-motion";

function MiniCard({ title, desc }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-black/30 p-5">
      <div className="text-sm font-semibold text-white">{title}</div>
      <div className="mt-1 text-xs leading-relaxed text-white/60">{desc}</div>
    </div>
  );
}

export default function CareersSection() {
  return (
    <section id="careers" className="bg-black">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:py-20">
        <motion.div
          className="rounded-3xl border border-white/10 bg-white/5 p-8 sm:p-10"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <div className="grid gap-10 md:grid-cols-2 md:items-center">
            <div>
              <div className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-red">Careers</div>
              <h3 className="mt-3 text-2xl font-bold tracking-tight text-white sm:text-3xl">
                Build with a small team that ships.
              </h3>
              <p className="mt-3 text-white/65">
                We’re assembling talent for design, gameplay, and production. If you love polish and iteration,
                we’ll vibe.
              </p>

              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <a
                  href="#contact"
                  className="rounded-xl bg-brand-red px-6 py-3 text-sm font-semibold text-white shadow-soft transition hover:opacity-90"
                >
                  Apply / Collaborate
                </a>
                <a
                  href="#contact"
                  className="rounded-xl border border-white/15 px-6 py-3 text-sm font-semibold text-white transition hover:border-white/30"
                >
                  Partnerships
                </a>
              </div>
            </div>

            <div className="grid gap-3 sm:grid-cols-2">
              <MiniCard title="Gameplay Dev" desc="Unity / Unreal / WebGL — strong fundamentals." />
              <MiniCard title="UI/UX" desc="Menus, HUDs, motion, and clean layout." />
              <MiniCard title="3D / VFX" desc="Stylized or realistic — strong look-dev." />
              <MiniCard title="Producer" desc="Scope, milestones, and shipping discipline." />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
